export interface DayPlan {
  day: number;
  title: string;
  activities: string[];
  accommodation: string;
  meals: string;
}

export interface Attraction {
  name: string;
  description: string;
  icon: string;
}

export interface DestinationDetail {
  id: number;
  name: string;
  subtitle: string;
  description: string;
  image: string;
  price: string;
  duration: string;
  features: string[];
  difficulty: string;
  bestSeason: string;
  startCity: string;
  endCity: string;
  highlights: string[];
  itinerary: DayPlan[];
  attractions: Attraction[];
  included: string[];
  excluded: string[];
}

export const destinationDetails: DestinationDetail[] = [
  {
    id: 1,
    name: "川藏線",
    subtitle: "天路之旅",
    description: "從成都出發，沿318國道穿越橫斷山脈，抵達聖城拉薩。全程約2100公里，是中國最壯麗也最具挑戰性的自駕線路，沿途經過折多山、新都橋、理塘、然烏湖、林芝，每一處都是大自然的鬼斧神工。",
    image: "https://public.readdy.ai/ai/img_res/70f2b05ffd5374a7459051ef1ca58e14.jpg",
    price: "需要報價",
    duration: "10天9晚",
    features: ["專業領隊", "高原適應指導", "氧氣瓶供應"],
    difficulty: "進階",
    bestSeason: "5月－10月",
    startCity: "成都",
    endCity: "拉薩",
    highlights: ["折多山海拔4298米", "新都橋攝影天堂", "理塘世界高城", "然烏湖冰川倒影", "林芝桃花仙境", "布達拉宮聖地朝聖"],
    itinerary: [
      { day: 1, title: "香港出發 → 成都", activities: ["由香港自駕出發北上", "抵達成都集合", "品嚐成都特色小吃"], accommodation: "雅安精品酒店", meals: "晚餐" },
      { day: 2, title: "雅安 → 康定（折多山）", activities: ["翻越折多山（海拔4298米）", "康定情歌廣場漫步", "木格措景區"], accommodation: "康定特色民宿", meals: "早餐、晚餐" },
      { day: 3, title: "康定 → 新都橋", activities: ["塔公草原騎馬", "新都橋攝影天堂日落拍攝", "藏族家訪體驗"], accommodation: "新都橋客棧", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "新都橋 → 理塘", activities: ["翻越高爾寺山", "理塘寺參觀", "世界高城廣場漫步"], accommodation: "理塘精品客棧", meals: "早餐、晚餐" },
      { day: 5, title: "理塘 → 芒康", activities: ["鹽井鹽田（千年古鹽田）", "如美溫泉浸泡", "芒康縣城遊覽"], accommodation: "芒康如家酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "芒康 → 左貢（業拉山）", activities: ["業拉山72拐（天路奇觀）", "怒江大峽谷眺望", "左貢縣城"], accommodation: "左貢溫泉酒店", meals: "早餐、晚餐" },
      { day: 7, title: "左貢 → 然烏湖", activities: ["來古冰川徒步", "然烏湖冰川倒影攝影", "湖邊帳篷露營"], accommodation: "然烏湖畔露營營地", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "然烏湖 → 林芝", activities: ["魯朗林海漫步", "扎西崗村藏家午餐", "南迦巴瓦峰眺望"], accommodation: "林芝精品民宿", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "林芝 → 拉薩", activities: ["米拉山口（海拔5013米）", "抵達拉薩", "八廓街初探"], accommodation: "拉薩四星酒店", meals: "早餐、晚餐" },
      { day: 10, title: "拉薩遊覽 → 自駕返港", activities: ["布達拉宮參觀", "大昭寺轉經", "自駕啟程返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "折多山", description: "海拔4298米，川藏線第一關，被稱為「康巴第一關」，山頂可遠眺貢嘎雪山。", icon: "ri-mountain-line" },
      { name: "新都橋", description: "攝影天堂，陽光在草地上投下金光，藏式村莊、河流、白楊樹構成絕美畫面。", icon: "ri-camera-line" },
      { name: "然烏湖", description: "西藏最美高原湖泊，湛藍湖水映照來古冰川，被稱為「西藏小瑞士」。", icon: "ri-water-flash-line" },
      { name: "林芝", description: "西藏的江南，3月桃花盛開時節，雪山與桃花相映成趣，美如仙境。", icon: "ri-plant-line" },
      { name: "布達拉宮", description: "世界上海拔最高的宮殿，藏傳佛教聖地，依山而建，氣勢磅礴。", icon: "ri-building-line" },
      { name: "業拉山72拐", description: "從山頂俯瞰72個髮夾彎盤旋而下，是川藏線最具挑戰性也最震撼的路段。", icon: "ri-road-map-line" },
    ],
    included: ["全程越野車接送", "10晚住宿（含露營）", "專業高原嚮導", "氧氣瓶（每人2瓶）", "景區門票（含布達拉宮）", "全程含餐（早餐10次、午餐8次、晚餐9次）", "高原急救藥包", "旅遊保險"],
    excluded: ["個人消費", "簽注費用（外籍人士）", "個人購物"],
  },
  {
    id: 2,
    name: "青海湖",
    subtitle: "天空之鏡",
    description: "青海湖是中國最大的鹹水湖，環湖公路全長360公里，沿途有茶卡鹽湖、黑馬河日出觀景點、沙島等絕美景色。每年夏季，湖畔的油菜花海與湛藍天空相映成趣，是攝影愛好者的天堂。",
    image: "https://readdy.ai/api/search-image?query=Stunning%20Qinghai%20Lake%20scenery%20with%20vast%20blue%20waters%20reflecting%20white%20clouds%2C%20endless%20yellow%20rape%20flower%20fields%20in%20foreground%2C%20winding%20lake%20road%20disappearing%20into%20horizon%2C%20Tibetan%20prayer%20stones%20along%20shore%2C%20professional%20landscape%20photography%2C%20vibrant%20colors%2C%20dreamy%20atmosphere&width=800&height=600&seq=102&orientation=landscape",
    price: "需要報價",
    duration: "5天4晚",
    features: ["環湖騎行", "茶卡鹽湖", "日出觀賞"],
    difficulty: "輕鬆",
    bestSeason: "6月－9月",
    startCity: "西寧",
    endCity: "西寧",
    highlights: ["茶卡鹽湖天空之鏡", "黑馬河日出", "環湖油菜花海", "沙島沙丘體驗", "塔爾寺藏傳佛教聖地"],
    itinerary: [
      { day: 1, title: "香港出發 → 西寧", activities: ["由香港自駕出發", "抵達西寧", "東關清真大寺參觀", "西寧夜市美食探索"], accommodation: "西寧精品酒店", meals: "晚餐" },
      { day: 2, title: "茶卡鹽湖", activities: ["茶卡鹽湖天空之鏡拍攝", "鹽雕藝術區遊覽", "傍晚抵達黑馬河"], accommodation: "黑馬河牧家樂", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "黑馬河日出 → 環湖西路", activities: ["凌晨4:30起床看日出（最美日出點）", "環湖西路騎行或自駕", "油菜花海攝影"], accommodation: "海晏縣精品民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "海晏 → 沙島 → 二郎劍", activities: ["沙島沙丘滑沙體驗", "二郎劍景區遊覽", "環湖東路賞景"], accommodation: "西寧精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "塔爾寺 → 自駕返港", activities: ["塔爾寺藏傳佛教聖地參觀", "西寧傳統手工藝品採購", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "茶卡鹽湖", description: "被稱為「中國天空之鏡」，鹽湖水面如鏡，映照天空，行走其上如行雲端。", icon: "ri-water-flash-line" },
      { name: "黑馬河日出", description: "青海湖最佳日出觀賞點，清晨薄霧中旭日從湖面升起，如夢似幻。", icon: "ri-sun-line" },
      { name: "油菜花海", description: "每年7月，青海湖畔萬畝油菜花盛開，金黃色花海與藍色湖水相映，壯觀無比。", icon: "ri-plant-line" },
      { name: "沙島", description: "青海湖中唯一的沙島，擁有連綿沙丘，可滑沙、騎駱駝，體驗沙漠與湖泊的奇妙組合。", icon: "ri-landscape-line" },
      { name: "塔爾寺", description: "藏傳佛教格魯派六大寺院之一，以酥油花、壁畫、堆繡並稱「三絕」聞名於世。", icon: "ri-building-4-line" },
    ],
    included: ["全程舒適商務車", "4晚精品住宿", "茶卡鹽湖、二郎劍等門票", "全程含餐", "專業攝影指導", "旅遊保險"],
    excluded: ["個人消費", "塔爾寺部分殿堂門票"],
  },
  {
    id: 3,
    name: "獨庫公路",
    subtitle: "一日四季",
    description: "獨庫公路全長562公里，北起獨山子，南至庫車，穿越天山山脈腹地。沿途從草原、雪山到峽谷、戈壁，一日之內可體驗四季景色更迭，被譽為中國最美公路之一。每年僅開放約5個月。",
    image: "https://readdy.ai/api/search-image?query=Majestic%20Duku%20Highway%20winding%20through%20Tianshan%20Mountains%2C%20lush%20green%20alpine%20meadows%20with%20wildflowers%2C%20snow-capped%20peaks%20in%20distance%2C%20crystal%20clear%20mountain%20lake%2C%20dramatic%20switchback%20roads%2C%20professional%20travel%20photography%2C%20vibrant%20natural%20colors%2C%20epic%20scale&width=800&height=600&seq=103&orientation=landscape",
    price: "HK$15,000起",
    duration: "8天7晚",
    features: ["草原露營", "峽谷探秘", "美食體驗"],
    difficulty: "中等",
    bestSeason: "6月－10月",
    startCity: "烏魯木齊",
    endCity: "庫車",
    highlights: ["獨庫公路全程穿越", "那拉提草原", "喬爾瑪烈士陵園", "克孜爾石窟", "溫宿大峽谷"],
    itinerary: [
      { day: 1, title: "香港出發 → 獨山子", activities: ["由香港自駕出發", "抵達獨山子", "準備次日穿越公路"], accommodation: "獨山子舒適酒店", meals: "晚餐" },
      { day: 2, title: "穿越獨庫公路北段", activities: ["翻越海拔3000米達坂", "那拉提草原漫步", "草原騎馬體驗"], accommodation: "那拉提牧家帳篷", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "那拉提 → 喬爾瑪 → 庫車", activities: ["喬爾瑪烈士陵園祭拜", "獨庫公路最美路段拍攝", "抵達庫車古城"], accommodation: "庫車精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "庫車文化探秘", activities: ["克孜爾石窟壁畫欣賞", "庫車王府遊覽", "品嚐維吾爾族特色美食"], accommodation: "庫車精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "溫宿大峽谷", activities: ["溫宿天山神秘大峽谷徒步", "峽谷絕壁攀爬體驗", "地質奇觀拍攝"], accommodation: "阿克蘇商務酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "阿克蘇 → 輪臺", activities: ["輪臺胡楊林（秋季為最佳）", "塔里木河漫步", "烤全羊晚宴"], accommodation: "輪臺特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "輪臺 → 庫爾勒", activities: ["庫爾勒香梨採摘（限季節）", "孔雀河景觀", "鐵門關遊覽"], accommodation: "庫爾勒精品酒店", meals: "早餐、晚餐" },
      { day: 8, title: "庫爾勒 → 烏魯木齊返程", activities: ["大巴扎採購紀念品", "返回烏魯木齊", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "那拉提草原", description: "世界四大草原之一，天山腹地的伊犁草原，蒼翠欲滴，氈房散佈，牛羊成群。", icon: "ri-landscape-line" },
      { name: "克孜爾石窟", description: "中國最古老的佛教石窟，壁畫精美絕倫，是中西文化交融的珍貴見證。", icon: "ri-ancient-pavilion-line" },
      { name: "溫宿大峽谷", description: "天山南麓的神秘峽谷，赤紅色岩壁高聳入雲，地貌奇特，被譽為「天山第一峽」。", icon: "ri-mountain-2-line" },
      { name: "輪臺胡楊林", description: "秋季金黃的胡楊林美如油畫，胡楊「生而千年不死，死而千年不倒」的精神令人動容。", icon: "ri-plant-line" },
    ],
    included: ["全程越野車", "7晚住宿（含帳篷露營）", "專業嚮導", "獨庫公路沿途門票", "全程餐飲", "旅遊保險"],
    excluded: ["烏魯木齊往返機票", "個人消費", "部分景點可選活動費用"],
  },
  {
    id: 4,
    name: "海南島",
    subtitle: "熱帶風情",
    description: "海南島環島公路全長約1千公里，沿途穿越熱帶雨林、椰林海岸、漁村古鎮。從海口出發，經文昌、萬寧、陵水到三亞，再穿越五指山腹地返程，體驗「中國夏威夷」的多元風情。",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Hainan%20Island%20coastal%20highway%20with%20palm%20trees%20lining%20the%20road%2C%20turquoise%20ocean%20waters%2C%20white%20sand%20beach%2C%20luxury%20convertible%20car%20on%20road%2C%20tropical%20sunset%20with%20orange%20and%20pink%20sky%2C%20professional%20travel%20photography%2C%20relaxing%20vacation%20atmosphere&width=800&height=600&seq=104&orientation=landscape",
    price: "HK$5,000起",
    duration: "6天5晚",
    features: ["海邊民宿", "潛水體驗", "海鮮美食"],
    difficulty: "輕鬆",
    bestSeason: "10月－4月",
    startCity: "海口",
    endCity: "海口",
    highlights: ["亞龍灣潛水", "天涯海角", "分界洲島浮潛", "五指山熱帶雨林", "文昌航天發射中心"],
    itinerary: [
      { day: 1, title: "香港出發 → 海口", activities: ["由香港自駕出發", "抵達海口", "中山路騎樓老街漫步", "海南粉、文昌雞等特色美食"], accommodation: "海口海景精品酒店", meals: "晚餐" },
      { day: 2, title: "海口 → 文昌 → 瓊海", activities: ["文昌航天發射中心參觀", "椰林大道自駕", "瓊海博鰲亞洲論壇會址"], accommodation: "瓊海海邊民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "瓊海 → 萬寧（石梅灣）", activities: ["日月灣衝浪體驗", "石梅灣私密白沙灘漫步", "神州半島夕陽觀賞"], accommodation: "石梅灣海邊度假民宿", meals: "早餐、晚餐" },
      { day: 4, title: "萬寧 → 陵水 → 三亞", activities: ["分界洲島浮潛（珊瑚礁）", "陵水新村漁港品生猛海鮮", "抵達三亞"], accommodation: "三亞精品海景酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "三亞深度遊", activities: ["亞龍灣深潛體驗", "天涯海角景區", "三亞夜市採購"], accommodation: "三亞精品海景酒店", meals: "早餐、晚餐" },
      { day: 6, title: "五指山 → 海口返港", activities: ["五指山熱帶雨林徒步", "黎族村寨參觀", "自駕返港"], accommodation: "——", meals: "早餐、午餐" },
    ],
    attractions: [
      { name: "亞龍灣", description: "被稱為「天下第一灣」，沙質細白如粉，海水清澈透明，能見度達7米，是潛水聖地。", icon: "ri-sailboat-line" },
      { name: "分界洲島", description: "海南最美的無人島之一，四面環海，珊瑚礁豐富，浮潛可見五彩熱帶魚。", icon: "ri-island-line" },
      { name: "天涯海角", description: "中國最南端的地標，「天涯」「海角」兩石相望，見證無數浪漫故事。", icon: "ri-map-pin-line" },
      { name: "五指山", description: "海南的「肺葉」，熱帶雨林鬱鬱蔥蔥，黎族文化在此保存最為完整。", icon: "ri-mountain-line" },
      { name: "文昌航天城", description: "中國最新的航天發射場，可近距離觀看火箭發射台，感受科技與自然的震撼。", icon: "ri-rocket-line" },
    ],
    included: ["全程舒適MPV車型", "5晚精品住宿", "分界洲島浮潛裝備", "部分門票", "全程餐飲", "旅遊保險"],
    excluded: ["海口往返機票", "個人消費", "深潛（選配）", "個人購物"],
  },
  {
    id: 5,
    name: "雲南環線",
    subtitle: "彩雲之南",
    description: "從昆明出發，穿越大理洱海、麗江古城、虎跳峽，最終抵達香格里拉。沿途集山川湖泊、民族文化、雪山峽谷於一體，是中國最受歡迎的自駕環線之一。",
    image: "https://readdy.ai/api/search-image?query=Scenic%20Yunnan%20road%20trip%20landscape%20with%20ancient%20Lijiang%20old%20town%2C%20Erhai%20Lake%20reflecting%20mountains%2C%20colorful%20ethnic%20villages%2C%20blooming%20flowers%2C%20traditional%20architecture%2C%20professional%20travel%20photography%2C%20warm%20golden%20lighting%2C%20vibrant%20cultural%20atmosphere&width=800&height=600&seq=105&orientation=landscape",
    price: "HK$3,299",
    duration: "7天6晚",
    features: ["古城漫步", "民族文化", "高原湖泊"],
    difficulty: "輕鬆",
    bestSeason: "3月－6月、9月－11月",
    startCity: "昆明",
    endCity: "昆明",
    highlights: ["洱海環湖騎行", "麗江束河古鎮", "虎跳峽徒步", "獨克宗古城", "梅里雪山神瀑"],
    itinerary: [
      { day: 1, title: "香港出發 → 麻市", activities: ["由香港自駕出發", "抵達麻市", "蒼山洱海初覽"], accommodation: "大理洱海民宿", meals: "晚餐" },
      { day: 2, title: "大理洱海環遊", activities: ["洱海遊船", "雙廊古鎮漫步", "三塔倒影攝影"], accommodation: "大理洱海民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "大理 → 麗江", activities: ["沙溪古鎮午餐", "麗江古城四方街", "束河古鎮夜遊"], accommodation: "麗江古城客棧", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "麗江深度遊", activities: ["玉龍雪山冰川公園", "藍月谷", "納西族文化演出"], accommodation: "麗江古城客棧", meals: "早餐、晚餐" },
      { day: 5, title: "麗江 → 虎跳峽 → 香格里拉", activities: ["虎跳峽徒步（中路）", "香格里拉獨克宗古城", "松贊林寺"], accommodation: "香格里拉藏式民宿", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "香格里拉深度遊", activities: ["普達措國家公園", "屬都湖", "高山草甸騎馬"], accommodation: "香格里拉藏式民宿", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "香格里拉 → 返港", activities: ["梅里雪山遠眺", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "洱海", description: "雲南高原上的明珠，環湖公路全長117公里，沿途白族村落、古塔、海灣景色如畫。", icon: "ri-water-flash-line" },
      { name: "玉龍雪山", description: "北半球最南端的大型海洋性冰川，主峰海拔5596米，雪峰倒映藍月谷，如夢如幻。", icon: "ri-mountain-line" },
      { name: "虎跳峽", description: "世界最深峽谷之一，金沙江在此奔騰而過，最窄處僅30米，氣勢磅礴。", icon: "ri-landscape-line" },
      { name: "獨克宗古城", description: "中國最大最完整的藏民居群，青石板路、藏式民居、轉經筒，散發濃郁藏式風情。", icon: "ri-ancient-pavilion-line" },
    ],
    included: ["全程舒適車輛", "6晚特色住宿", "主要景區門票", "全程餐飲", "旅遊保險"],
    excluded: ["昆明往返機票", "玉龍雪山大索道（選配）", "個人消費"],
  },
  {
    id: 6,
    name: "內蒙古草原",
    subtitle: "天蒼蒼野茫茫",
    description: "呼倫貝爾大草原被譽為「世界上最美麗的草原」，翠綠無際的草地、成群的牛羊、潔白的蒙古包，構成一幅壯闊的遊牧圖畫。夏季鮮花盛開，秋季草黃天藍，四季各有其美。",
    image: "https://readdy.ai/api/search-image?query=Vast%20Inner%20Mongolia%20grassland%20with%20endless%20green%20plains%2C%20white%20yurts%20scattered%20across%20landscape%2C%20horses%20grazing%2C%20blue%20sky%20with%20white%20clouds%2C%20winding%20dirt%20road%2C%20professional%20travel%20photography%2C%20peaceful%20pastoral%20atmosphere%2C%20wide%20angle%20view&width=800&height=600&seq=106&orientation=landscape",
    price: "HK$10,000起",
    duration: "6天5晚",
    features: ["騎馬體驗", "蒙古包住宿", "篝火晚會"],
    difficulty: "輕鬆",
    bestSeason: "6月－9月",
    startCity: "海拉爾",
    endCity: "海拉爾",
    highlights: ["呼倫貝爾草原騎馬", "滿洲里套娃廣場", "額爾古納濕地", "莫日格勒河九曲灣", "室韋俄羅斯民族鄉"],
    itinerary: [
      { day: 1, title: "香港出發 → 海拉爾", activities: ["由香港自駕出發", "抵達海拉爾", "成吉思汗廣場參觀", "草原迎賓儀式"], accommodation: "蒙古包特色營地", meals: "晚餐（蒙古族特色宴）" },
      { day: 2, title: "呼倫貝爾大草原", activities: ["騎馬穿越草原", "蒙古包生活體驗", "馬奶酒品嚐"], accommodation: "草原蒙古包", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "莫日格勒河 → 室韋", activities: ["九曲灣觀景台", "沿額爾古納河自駕", "室韋俄羅斯族村落"], accommodation: "室韋特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "額爾古納濕地", activities: ["濕地木棧道漫步", "觀鳥（丹頂鶴等）", "根河市遊覽"], accommodation: "根河精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "滿洲里 → 呼倫湖", activities: ["套娃廣場俄式風情", "呼倫湖觀鳥", "邊境風情體驗"], accommodation: "滿洲里酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "海拉爾 → 自駕返港", activities: ["海拉爾要塞遺址", "手工藝品採購", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "莫日格勒河", description: "「天下第一曲水」，蜿蜒的河流在綠色草原上畫出無數S形曲線，從高處俯瞰如龍飛翔。", icon: "ri-water-flash-line" },
      { name: "額爾古納濕地", description: "中國最大的濕地之一，蘆葦叢生、候鳥雲集，是大自然賜予的生態寶庫。", icon: "ri-landscape-line" },
      { name: "室韋俄羅斯族鄉", description: "中俄邊境小鎮，俄式木屋、東正教教堂，是中國境內俄羅斯族的聚居地。", icon: "ri-home-heart-line" },
    ],
    included: ["全程越野車", "5晚住宿（含蒙古包）", "騎馬體驗", "篝火晚會", "全程餐飲", "旅遊保險"],
    excluded: ["海拉爾往返機票", "個人消費"],
  },
  {
    id: 7,
    name: "絲綢之路",
    subtitle: "千年古道",
    description: "沿古絲綢之路從西安出發，途經天水麥積山、蘭州、張掖、酒泉、嘉峪關，最終抵達敦煌莫高窟。全程約2500公里，跨越千年歷史，感受中原文明與西域文化的交融。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Silk%20Road%20landscape%20with%20Mogao%20Caves%2C%20desert%20sand%20dunes%2C%20camel%20caravans%2C%20historic%20ruins%2C%20dramatic%20sunset%20over%20Gobi%20Desert%2C%20professional%20travel%20photography%2C%20mystical%20atmosphere%2C%20golden%20hour%20lighting&width=800&height=600&seq=107&orientation=landscape",
    price: "HK$4,599",
    duration: "9天8晚",
    features: ["歷史遺跡", "沙漠探險", "文化體驗"],
    difficulty: "中等",
    bestSeason: "4月－10月",
    startCity: "西安",
    endCity: "敦煌",
    highlights: ["兵馬俑", "麥積山石窟", "張掖丹霞", "嘉峪關長城", "鳴沙山月牙泉", "莫高窟壁畫"],
    itinerary: [
      { day: 1, title: "香港出發 → 西安", activities: ["由香港自駕出發", "抵達西安", "城牆騎行", "前往天水"], accommodation: "天水精品酒店", meals: "晚餐" },
      { day: 2, title: "麥積山", activities: ["麥積山石窟（東方雕塑館）", "前往蘭州", "黃河鐵橋夜景"], accommodation: "蘭州精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "蘭州 → 武威", activities: ["白塔山公園", "蘭州牛肉麵早餐", "武威雷台漢墓（銅奔馬故鄉）"], accommodation: "武威舒適酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "武威 → 張掖丹霞", activities: ["馬蹄寺石窟", "張掖七彩丹霞地貌", "絕色日落拍攝"], accommodation: "張掖精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "張掖 → 酒泉 → 嘉峪關", activities: ["大佛寺木臥佛", "酒泉公園", "嘉峪關長城"], accommodation: "嘉峪關酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "嘉峪關 → 玉門關 → 敦煌", activities: ["天下第一雄關", "玉門關遺址", "漢長城烽燧"], accommodation: "敦煌精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "敦煌莫高窟", activities: ["莫高窟壁畫參觀（導覽）", "敦煌博物館", "沙州夜市"], accommodation: "敦煌精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "鳴沙山月牙泉", activities: ["騎駱駝穿越鳴沙山", "月牙泉日落", "敦煌夜市美食"], accommodation: "敦煌精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "敦煌返港", activities: ["敦煌機場送機", "自駕啟程返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "莫高窟", description: "世界文化遺產，735個洞窟、4.5萬平方米壁畫，是人類藝術寶庫，被稱為「沙漠中的美術館」。", icon: "ri-ancient-pavilion-line" },
      { name: "鳴沙山月牙泉", description: "沙山環抱一彎清泉，風吹沙響如鳴，千年不竭，是自然奇觀中的詩意奇蹟。", icon: "ri-landscape-line" },
      { name: "嘉峪關", description: "「天下第一雄關」，絲綢之路咽喉，長城最西端，氣勢雄偉，歷史厚重。", icon: "ri-building-4-line" },
      { name: "張掖丹霞", description: "七彩斑斕的地質奇觀，紅橙黃綠藍靛紫的岩層，是大自然的調色盤。", icon: "ri-palette-line" },
    ],
    included: ["全程SUV車輛", "8晚精品住宿", "莫高窟門票", "全程餐飲", "資深文化嚮導", "旅遊保險"],
    excluded: ["西安出發機票", "敦煌返程機票", "個人消費"],
  },
  {
    id: 8,
    name: "桂林山水",
    subtitle: "山水甲天下",
    description: "漓江發源於越城嶺，流經桂林、陽朔，沿岸喀斯特地貌千峰競秀。竹筏漂流、岩洞探秘、田園騎行，在這片「人間仙境」中慢下腳步，感受桂林山水的詩意之美。",
    image: "https://readdy.ai/api/search-image?query=Stunning%20Guilin%20karst%20mountains%20landscape%20with%20Li%20River%2C%20traditional%20bamboo%20rafts%2C%20misty%20morning%20atmosphere%2C%20limestone%20peaks%20reflecting%20in%20calm%20water%2C%20rural%20villages%2C%20professional%20travel%20photography%2C%20serene%20natural%20beauty&width=800&height=600&seq=108&orientation=landscape",
    price: "HK$5,000起",
    duration: "5天4晚",
    features: ["漓江遊船", "溶洞探秘", "田園風光"],
    difficulty: "輕鬆",
    bestSeason: "3月－11月",
    startCity: "桂林",
    endCity: "桂林",
    highlights: ["漓江竹筏漂流", "十里畫廊騎行", "蘆笛岩溶洞", "陽朔西街", "龍脊梯田"],
    itinerary: [
      { day: 1, title: "香港出發 → 桂林", activities: ["由香港自駕出發", "抵達桂林", "象鼻山", "兩江四湖遊覽", "桂林米粉晚餐"], accommodation: "桂林精品酒店", meals: "晚餐" },
      { day: 2, title: "漓江遊船 → 陽朔", activities: ["桂林至陽朔漓江遊船（4小時）", "陽朔西街漫步", "夜遊西街"], accommodation: "陽朔特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "陽朔周邊", activities: ["十里畫廊騎行", "月亮山", "遇龍河竹筏漂流"], accommodation: "陽朔特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "龍脊梯田", activities: ["龍脊梯田（春夏水田倒影 / 秋季金黃）", "瑤族村寨", "傳統手工藝體驗"], accommodation: "桂林精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "蘆笛岩 → 返港", activities: ["蘆笛岩地下溶洞", "七星公園", "自駕返港"], accommodation: "——", meals: "早餐、午餐" },
    ],
    attractions: [
      { name: "漓江", description: "「桂林山水甲天下，陽朔山水甲桂林」，漓江兩岸奇峰如筆，是中國最美的河流之一。", icon: "ri-water-flash-line" },
      { name: "龍脊梯田", description: "壯族和瑤族先民開墾，層層梯田盤旋至雲霧之中，春夏秋冬各有不同的震撼美景。", icon: "ri-landscape-line" },
      { name: "蘆笛岩", description: "「大自然的藝術之宮」，地下溶洞鐘乳石奇形怪狀，流光溢彩，美輪美奐。", icon: "ri-compass-3-line" },
      { name: "遇龍河", description: "被稱為「小漓江」，可乘竹筏悠然漂流，兩岸翠竹青山，比漓江更為靜謐。", icon: "ri-sailboat-line" },
    ],
    included: ["全程舒適車輛", "4晚特色民宿", "漓江遊船票", "遇龍河竹筏", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費", "桂林往返機票", "蘆笛岩可選燈光秀"],
  },
  {
    id: 9,
    name: "張家界",
    subtitle: "阿凡達仙境",
    description: "張家界是世界上第一個以地貌景觀為對象的自然保護區，奇峰3000餘座，壯觀的石柱林立於雲霧之中，被稱為電影《阿凡達》的現實原型。天門山、武陵源、天子山構成完整的奇幻仙境。",
    image: "https://readdy.ai/api/search-image?query=Spectacular%20Zhangjiajie%20National%20Forest%20Park%20with%20towering%20sandstone%20pillars%2C%20glass%20skywalk%20on%20cliff%20edge%2C%20misty%20mountains%2C%20lush%20green%20vegetation%2C%20dramatic%20vertical%20cliffs%2C%20professional%20travel%20photography%2C%20mystical%20atmosphere&width=800&height=600&seq=109&orientation=landscape",
    price: "需要報價",
    duration: "5天4晚",
    features: ["玻璃棧道", "纜車體驗", "奇峰異石"],
    difficulty: "中等",
    bestSeason: "4月－10月",
    startCity: "張家界",
    endCity: "張家界",
    highlights: ["天門山玻璃棧道", "武陵源索道", "天子山御筆峰", "黃龍洞地下溶洞", "寶峰湖遊船"],
    itinerary: [
      { day: 1, title: "香港出發 → 張家界", activities: ["由香港自駕出發", "抵達張家界", "土家族風情街", "土家族特色晚宴"], accommodation: "張家界精品酒店", meals: "晚餐" },
      { day: 2, title: "武陵源核心景區", activities: ["袁家界（阿凡達取景地）", "天子山御筆峰", "十里畫廊電瓶車"], accommodation: "武陵源山景酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "天門山", activities: ["天門山索道（全球最長客運索道）", "天門洞999級天梯", "玻璃棧道體驗"], accommodation: "張家界精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "黃龍洞 → 寶峰湖", activities: ["黃龍洞地下溶洞（4億年地質奇觀）", "寶峰湖遊船", "土家族文化演出"], accommodation: "張家界精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "返港", activities: ["慈利江埡溫泉（選配）", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "天門山", description: "懸崖峭壁上的玻璃棧道令人心跳加速，天門洞999級天梯直通天際，是勇者的挑戰。", icon: "ri-mountain-line" },
      { name: "袁家界", description: "《阿凡達》潘多拉星球的現實原型，懸空山石柱在雲霧中若隱若現，如夢幻世界。", icon: "ri-landscape-line" },
      { name: "黃龍洞", description: "世界地質公園，地下溶洞長達7.5公里，鐘乳石、石筍、石柱構成地下宮殿。", icon: "ri-compass-3-line" },
    ],
    included: ["全程車輛", "4晚精品住宿", "武陵源、天門山門票", "黃龍洞、寶峰湖門票", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費", "玻璃橋（選配）"],
  },
  {
    id: 10,
    name: "東北雪鄉",
    subtitle: "冰雪奇緣",
    description: "東北雪鄉（亞布力雪鄉）是中國降雪量最大的地區之一，積雪厚達2米，村莊屋頂被厚厚白雪覆蓋，宛如童話世界。哈爾濱冰雕節、雪地摩托、溫泉養生，構成冬日完美行程。",
    image: "https://readdy.ai/api/search-image?query=Magical%20China%20Snow%20Town%20winter%20landscape%20with%20traditional%20houses%20covered%20in%20thick%20snow%2C%20warm%20lights%20glowing%20from%20windows%2C%20ice%20sculptures%2C%20frozen%20trees%2C%20snowy%20mountain%20village%2C%20professional%20travel%20photography%2C%20cozy%20winter%20atmosphere&width=800&height=600&seq=110&orientation=landscape",
    price: "HK$10,000起",
    duration: "6天5晚",
    features: ["冰雕藝術", "滑雪體驗", "溫泉養生"],
    difficulty: "輕鬆",
    bestSeason: "12月－2月",
    startCity: "哈爾濱",
    endCity: "哈爾濱",
    highlights: ["哈爾濱冰雪大世界", "雪鄉童話村落", "亞布力滑雪場", "鏡泊湖冬釣", "牡丹江雪地摩托"],
    itinerary: [
      { day: 1, title: "香港出發 → 哈爾濱", activities: ["由香港自駕出發", "抵達哈爾濱", "中央大街俄式建築漫步", "馬迭爾冰棍品嚐"], accommodation: "哈爾濱精品酒店", meals: "晚餐" },
      { day: 2, title: "冰雪大世界", activities: ["哈爾濱冰雪大世界（夜間最美）", "冰雕藝術欣賞", "冰滑梯體驗"], accommodation: "哈爾濱精品酒店", meals: "早餐、晚餐" },
      { day: 3, title: "雪鄉", activities: ["前往雪鄉（約4小時車程）", "雪鄉村落漫步攝影", "篝火晚會"], accommodation: "雪鄉特色木屋", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "雪鄉深度體驗", activities: ["雪地摩托體驗", "雪鄉早晨攝影黃金時段", "返回牡丹江"], accommodation: "牡丹江精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "亞布力滑雪", activities: ["亞布力滑雪場初/中級道", "滑雪教練指導", "溫泉養生"], accommodation: "亞布力滑雪場酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "哈爾濱 → 自駕返港", activities: ["索菲亞教堂", "道外巴洛克建築", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "哈爾濱冰雪大世界", description: "全球最大冰雕藝術節，數千件冰雕作品在彩燈照耀下璀璨奪目，夜間尤為震撼。", icon: "ri-building-line" },
      { name: "雪鄉", description: "中國降雪最豐富的村落，家家屋頂積雪如帽，黃昏燈亮後如同《冰雪奇緣》的場景。", icon: "ri-home-3-line" },
      { name: "亞布力滑雪場", description: "中國最大的滑雪場，有初中高級雪道多條，雪質優良，是冬季運動天堂。", icon: "ri-run-line" },
    ],
    included: ["全程車輛", "5晚住宿（含雪鄉木屋）", "冰雪大世界門票", "雪地摩托體驗", "全程餐飲", "旅遊保險"],
    excluded: ["哈爾濱往返機票", "亞布力滑雪裝備租賃", "個人消費"],
  },
  {
    id: 11,
    name: "福建土樓",
    subtitle: "客家文化",
    description: "福建土樓是世界文化遺產，是客家先民歷經千年智慧結晶的建築奇觀。圓形或方形的巨大土樓，直徑達70米，可住數百人，被稱為「東方古城堡」。閩南茶文化與土樓文明在此交融。",
    image: "https://readdy.ai/api/search-image?query=UNESCO%20World%20Heritage%20Fujian%20Tulou%20circular%20earthen%20buildings%20surrounded%20by%20green%20tea%20plantations%2C%20traditional%20Hakka%20architecture%2C%20rural%20mountain%20landscape%2C%20professional%20travel%20photography%2C%20cultural%20heritage%20atmosphere&width=800&height=600&seq=111&orientation=landscape",
    price: "HK$5,000起",
    duration: "4天3晚",
    features: ["土樓參觀", "茶園體驗", "客家美食"],
    difficulty: "輕鬆",
    bestSeason: "全年皆宜",
    startCity: "廈門",
    endCity: "廈門",
    highlights: ["永定土樓群", "南靖田螺坑土樓", "安溪鐵觀音茶園", "客家美食體驗", "土樓民宿住宿"],
    itinerary: [
      { day: 1, title: "香港出發 → 廈門", activities: ["由香港自駕出發", "抵達廈門", "廈門海景精品酒店", "南普陀寺", "廈門大學校園"], accommodation: "土樓特色民宿", meals: "晚餐（客家菜）" },
      { day: 2, title: "土樓深度探訪", activities: ["振成樓（土樓之王）", "承啟樓（世界最大圓形土樓）", "客家文化表演"], accommodation: "土樓特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "南靖田螺坑 → 茶園", activities: ["南靖田螺坑土樓群（四圓一方）", "安溪茶園體驗採茶", "鐵觀音茶藝表演"], accommodation: "廈門精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "廈門返程", activities: ["曉起古村（百年香樟樹）", "婺源茶道體驗", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "田螺坑土樓群", description: "「四菜一湯」的神奇佈局，四個圓形土樓圍繞一個方形土樓，從高空俯瞰絕美。", icon: "ri-ancient-pavilion-line" },
      { name: "承啟樓", description: "世界最大的圓形土樓，直徑73米，共四環，住有600多人，被譽為「土樓王」。", icon: "ri-building-4-line" },
      { name: "安溪茶園", description: "鐵觀音的故鄉，連綿茶山翠綠，茶香四溢，可親身體驗採茶、製茶、品茶全過程。", icon: "ri-cup-line" },
    ],
    included: ["全程舒適車輛", "3晚住宿（含土樓民宿）", "土樓群門票", "茶園體驗", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 12,
    name: "西藏珠峰",
    subtitle: "世界之巔",
    description: "珠峰大本營海拔5200米，是普通人能到達的離世界最高峰最近的地方。從拉薩出發，穿越羊卓雍措、卡若拉冰川，抵達日喀則、薩迦寺，最終站在世界屋脊仰望珠穆朗瑪峰，完成人生壯舉。",
    image: "https://readdy.ai/api/search-image?query=Majestic%20Mount%20Everest%20base%20camp%20view%20with%20snow-covered%20peak%2C%20Tibetan%20prayer%20flags%2C%20dramatic%20mountain%20landscape%2C%20clear%20blue%20sky%2C%20professional%20travel%20photography%2C%20epic%20scale%2C%20inspiring%20atmosphere&width=800&height=600&seq=112&orientation=landscape",
    price: "需要報價",
    duration: "12天11晚",
    features: ["珠峰大本營", "專業嚮導", "高原醫療"],
    difficulty: "進階",
    bestSeason: "4月－5月、9月－10月",
    startCity: "拉薩",
    endCity: "拉薩",
    highlights: ["珠峰大本營（5200米）", "羊卓雍措聖湖", "卡若拉冰川", "扎什倫布寺", "薩迦寺"],
    itinerary: [
      { day: 1, title: "拉薩適應日", activities: ["抵達拉薩（3650米）", "充分休息適應高原", "大昭寺廣場散步"], accommodation: "拉薩四星酒店", meals: "晚餐" },
      { day: 2, title: "拉薩深度遊", activities: ["布達拉宮（預約參觀）", "羅布林卡", "八廓街"], accommodation: "拉薩四星酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "拉薩 → 羊卓雍措", activities: ["羊卓雍措聖湖（4441米）", "卡若拉冰川", "前往日喀則"], accommodation: "日喀則酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "日喀則", activities: ["扎什倫布寺（班禪喇嘛駐錫地）", "日喀則市區", "準備珠峰之行"], accommodation: "日喀則酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "日喀則 → 薩迦", activities: ["薩迦寺（藏傳佛教重要寺院）", "前往珠峰保護區"], accommodation: "定日酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "定日 → 珠峰大本營", activities: ["喜馬拉雅山脈全景公路", "珠峰大本營（5200米）", "仰望珠穆朗瑪峰"], accommodation: "珠峰大本營帳篷", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "珠峰大本營 → 定日", activities: ["珠峰日出（清晨最美）", "各角度攝影", "返回定日"], accommodation: "定日酒店", meals: "早餐、晚餐" },
      { day: 8, title: "定日 → 吉隆", activities: ["吉隆溝（西藏最美峽谷之一）", "尼泊爾邊境風情"], accommodation: "吉隆特色民宿", meals: "早餐、晚餐" },
      { day: 9, title: "吉隆 → 日喀則", activities: ["吉隆峽谷風光", "返回日喀則"], accommodation: "日喀則酒店", meals: "早餐、晚餐" },
      { day: 10, title: "日喀則 → 拉薩", activities: ["雅魯藏布江風光", "返回拉薩"], accommodation: "拉薩四星酒店", meals: "早餐、晚餐" },
      { day: 11, title: "拉薩自由活動", activities: ["色拉寺辯經", "甜茶館體驗", "紀念品採購"], accommodation: "拉薩四星酒店", meals: "早餐" },
      { day: 12, title: "拉薩 → 自駕返港", activities: ["自駕啟程返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "珠峰大本營", description: "海拔5200米，是普通旅行者能到達的最近珠峰之處，仰望世界最高峰的震撼無法言喻。", icon: "ri-mountain-line" },
      { name: "羊卓雍措", description: "西藏三大聖湖之一，碧藍如翡翠，山水相映，被稱為「世界上最美的水」。", icon: "ri-water-flash-line" },
      { name: "扎什倫布寺", description: "班禪喇嘛的駐錫地，藏傳佛教格魯派六大寺院之一，壯觀的金頂在陽光下熠熠生輝。", icon: "ri-building-4-line" },
    ],
    included: ["全程越野車", "11晚住宿（含大本營帳篷）", "西藏旅遊許可證", "珠峰保護區門票", "高原醫療隨行", "氧氣瓶（每人3瓶）", "全程餐飲", "旅遊保險"],
    excluded: ["拉薩往返機票", "外籍人士簽注", "個人消費"],
  },
  {
    id: 13,
    name: "九寨溝",
    subtitle: "童話世界",
    description: "九寨溝以「翠海、疊瀑、彩林、雪峰」四絕著稱，108個湖泊色彩絢麗，水清見底。珍珠灘瀑布、五花海、鏡海、天鵝海，每一處都是大自然的神來之筆。",
    image: "https://readdy.ai/api/search-image?query=Breathtaking%20Jiuzhaigou%20Valley%20with%20colorful%20lakes%20in%20emerald%20and%20sapphire%20blue%2C%20cascading%20waterfalls%20through%20lush%20forests%2C%20autumn%20foliage%20reflections%2C%20snow-capped%20mountains%20in%20background%2C%20professional%20travel%20photography%2C%20pristine%20natural%20beauty&width=800&height=600&seq=113&orientation=landscape",
    price: "需要報價",
    duration: "5天4晚",
    features: ["彩池觀賞", "瀑布探秘", "原始森林"],
    difficulty: "輕鬆",
    bestSeason: "9月－11月（秋色最美）",
    startCity: "成都",
    endCity: "成都",
    highlights: ["五花海絕色彩池", "珍珠灘瀑布", "樹正群海", "長海", "藏族羌族文化體驗"],
    itinerary: [
      { day: 1, title: "香港出發 → 九寨溝", activities: ["由香港自駕出發", "抵達九寨溝"], accommodation: "九寨溝特色藏式酒店", meals: "晚餐" },
      { day: 2, title: "日則溝遊覽", activities: ["鏡海", "箭竹海", "熊貓海", "五花海（最美彩池）", "珍珠灘瀑布"], accommodation: "九寨溝特色藏式酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "樹正溝遊覽", activities: ["樹正群海", "犀牛海", "老虎海", "蘆葦海", "樹正瀑布"], accommodation: "九寨溝特色藏式酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "則查窪溝 → 藏族體驗", activities: ["長海（最長湖泊）", "五彩池（最小最美）", "藏族文化村體驗"], accommodation: "九寨溝特色藏式酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "九寨溝早晨攝影", activities: ["九寨溝早晨攝影", "返回成都", "錦里古街"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "五花海", description: "九寨溝最美的湖泊，湖底沉木與五彩礦物質共同形成翠綠、金黃、深藍等多種色彩。", icon: "ri-water-flash-line" },
      { name: "珍珠灘瀑布", description: "寬達162米，飛流直下，水珠飛濺如珍珠，是九寨溝規模最大、最壯觀的瀑布。", icon: "ri-drop-line" },
      { name: "五彩池", description: "九寨溝最小卻最色彩豐富的湖泊，色澤鮮豔，藍、綠、黃、橙、白各色交錯，如同調色盤。", icon: "ri-palette-line" },
    ],
    included: ["全程舒適車輛", "4晚藏式特色酒店", "九寨溝景區門票", "環保觀光車", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 14,
    name: "新疆喀納斯",
    subtitle: "神之後花園",
    description: "喀納斯湖是新疆最神秘的地方，湖水碧藍，四周白樺林秋色金黃，傳說中棲居著神秘「湖怪」。禾木村是中國最後的圖瓦人聚居地，木屋炊煙，草場馬群，如世外桃源。",
    image: "https://readdy.ai/api/search-image?query=Mystical%20Kanas%20Lake%20in%20Xinjiang%20with%20turquoise%20water%20surrounded%20by%20golden%20birch%20forests%2C%20traditional%20Tuva%20wooden%20houses%20in%20Hemu%20Village%2C%20misty%20mountains%2C%20autumn%20colors%2C%20professional%20travel%20photography%2C%20serene%20natural%20beauty&width=800&height=600&seq=114&orientation=landscape",
    price: "HK$15,000起",
    duration: "7天6晚",
    features: ["湖泊遊船", "圖瓦文化", "秋色攝影"],
    difficulty: "中等",
    bestSeason: "9月－10月（秋色最佳）",
    startCity: "烏魯木齊",
    endCity: "烏魯木齊",
    highlights: ["喀納斯湖神秘湖怪", "禾木村秋色", "白哈巴村", "賈登峪觀景台", "五彩灘雅丹地貌"],
    itinerary: [
      { day: 1, title: "香港出發 → 布爾津", activities: ["由香港自駕出發", "抵達布爾津", "額爾齊斯河夜市"], accommodation: "布爾津精品酒店", meals: "晚餐" },
      { day: 2, title: "五彩灘 → 喀納斯", activities: ["五彩灘（雅丹地貌）攝影", "前往喀納斯景區", "湖邊漫步"], accommodation: "喀納斯湖景民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "喀納斯湖深度遊", activities: ["神仙灣霧氣攝影", "月亮灣倒影", "臥龍灣", "觀魚台（俯瞰喀納斯）"], accommodation: "喀納斯湖景民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "禾木村", activities: ["禾木村圖瓦木屋聚落", "清晨炊煙攝影（最美時段）", "草場騎馬"], accommodation: "禾木村特色木屋", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "白哈巴村", activities: ["白哈巴邊境村", "哈薩克族牧民生活體驗", "邊境風情"], accommodation: "白哈巴民宿", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "返回布爾津", activities: ["額爾齊斯河石林", "哈薩克族奶茶體驗", "返回布爾津"], accommodation: "布爾津精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "返回烏魯木齊", activities: ["布爾津魚宴午餐", "返回烏魯木齊", "自駕返港"], accommodation: "——", meals: "早餐、午餐" },
    ],
    attractions: [
      { name: "喀納斯湖", description: "神秘的高山湖泊，水色隨天氣變化呈現藍綠色，湖中傳說棲居巨大「湖怪」，增添神秘色彩。", icon: "ri-water-flash-line" },
      { name: "禾木村", description: "中國最後的圖瓦人聚居地，秋天木屋炊煙、白樺金林，是攝影師夢寐以求的天堂。", icon: "ri-home-3-line" },
      { name: "五彩灘", description: "額爾齊斯河旁的彩色雅丹地貌，河對岸翠綠蘆葦與彩色岩層形成強烈反差，奇美無比。", icon: "ri-palette-line" },
    ],
    included: ["全程越野車", "6晚住宿（含木屋民宿）", "景區門票", "騎馬體驗", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 15,
    name: "張掖丹霞",
    subtitle: "七彩奇觀",
    description: "張掖丹霞地貌是中國丹霞地貌發育最大的地區，七彩山巒綿延數十公里，紅橙黃綠藍靛紫交錯排列，如大自然用巨筆塗抹的畫卷。嘉峪關長城與冰川遺跡共同構成絲路文明的壯美版圖。",
    image: "https://readdy.ai/api/search-image?query=Spectacular%20Zhangye%20Danxia%20landform%20with%20rainbow-colored%20striped%20mountains%20in%20red%20orange%20yellow%20layers%2C%20dramatic%20geological%20formations%2C%20sunset%20lighting%20enhancing%20colors%2C%20professional%20travel%20photography%2C%20otherworldly%20landscape&width=800&height=600&seq=115&orientation=landscape",
    price: "HK$2,699",
    duration: "5天4晚",
    features: ["丹霞觀賞", "長城遺跡", "地質探秘"],
    difficulty: "輕鬆",
    bestSeason: "7月－9月（雨後色彩最鮮豔）",
    startCity: "蘭州",
    endCity: "敦煌",
    highlights: ["張掖七彩丹霞", "嘉峪關長城", "馬蹄寺石窟", "山丹軍馬場", "平山湖大峽谷"],
    itinerary: [
      { day: 1, title: "香港出發 → 兰州", activities: ["由香港自駕出發", "抵達蘭州", "成吉思汗廣場參觀", "大佛寺臥佛"], accommodation: "張掖精品酒店", meals: "晚餐" },
      { day: 2, title: "張掖丹霞全天", activities: ["七彩丹霞晨光攝影", "冰溝丹霞（更原始壯觀）", "丹霞日落拍攝"], accommodation: "張掖精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "馬蹄寺 → 山丹", activities: ["馬蹄寺石窟群（裕固族聚居地）", "山丹軍馬場（中國最大軍馬場）", "祁連山雪景"], accommodation: "酒泉精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "嘉峪關", activities: ["嘉峪關長城（天下第一雄關）", "懸壁長城", "黑山岩畫"], accommodation: "嘉峪關酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "敦煌", activities: ["前往敦煌", "鳴沙山騎駱駝", "月牙泉"], accommodation: "——", meals: "早餐、午餐" },
    ],
    attractions: [
      { name: "七彩丹霞", description: "2400萬年地質運動的傑作，七種色彩的岩層交疊，夕陽照耀下色彩更加絢麗，堪稱地球調色盤。", icon: "ri-palette-line" },
      { name: "冰溝丹霞", description: "比七彩丹霞更原始粗獷，赤紅色岩壁在陽光下如燃烧的火焰，震撼人心。", icon: "ri-fire-line" },
      { name: "馬蹄寺", description: "祁連山腳下的石窟群，傳說天馬踏蹄留印於此，石窟壁畫精美，是絲路佛教藝術珍品。", icon: "ri-ancient-pavilion-line" },
    ],
    included: ["全程舒適車輛", "4晚精品住宿", "丹霞景區門票", "嘉峪關門票", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 16,
    name: "貴州黔東南",
    subtitle: "苗侗風情",
    description: "黔東南是中國少數民族文化保存最完整的地區之一，苗族和侗族在此世代繁衍。西江千戶苗寨是全球最大的苗族聚居村寨，肇興侗寨保存有完整的侗族大歌文化，梯田層疊，炊煙裊裊。",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Miao%20minority%20village%20in%20Guizhou%20with%20wooden%20stilt%20houses%20on%20hillside%2C%20Xijiang%20Qianhu%20Miao%20Village%20at%20night%20with%20warm%20lights%2C%20terraced%20fields%2C%20misty%20mountains%2C%20professional%20travel%20photography%2C%20ethnic%20cultural%20atmosphere&width=800&height=600&seq=116&orientation=landscape",
    price: "HK$5,000起",
    duration: "6天5晚",
    features: ["苗寨體驗", "侗族大歌", "梯田風光"],
    difficulty: "輕鬆",
    bestSeason: "4月－10月",
    startCity: "貴陽",
    endCity: "貴陽",
    highlights: ["西江千戶苗寨夜景", "肇興侗寨鼓樓", "加榜梯田", "鎮遠古城", "舞陽河漂流"],
    itinerary: [
      { day: 1, title: "香港出發 → 贵陽", activities: ["由香港自駕出發", "抵達貴陽", "鎮遠古城漫步", "土家族風情街"], accommodation: "貴陽精品酒店", meals: "晚餐" },
      { day: 2, title: "舞陽河 → 西江苗寨", activities: ["舞陽河竹筏漂流", "前往西江千戶苗寨", "苗寨夜景（最佳觀賞時間）"], accommodation: "西江苗家吊腳樓民宿", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "西江苗寨深度遊", activities: ["苗族長桌宴體驗", "苗族銀飾刺繡工藝", "觀景台俯瞰全寨"], accommodation: "西江苗家吊腳樓民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "加榜梯田", activities: ["加榜梯田（中國最美梯田之一）", "苗族村寨生活體驗", "稻田攝影"], accommodation: "苗寨特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "肇興侗寨", activities: ["肇興侗寨五座鼓樓", "侗族大歌表演", "風雨橋漫步"], accommodation: "侗寨特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "返回貴陽", activities: ["黎平翹街", "返回貴陽", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "西江千戶苗寨", description: "全球最大的苗族聚居村寨，1285戶苗家木樓依山而建，夜晚燈光璀璨，如仙境般美麗。", icon: "ri-home-3-line" },
      { name: "肇興侗寨", description: "中國最大的侗族村寨，五座風格各異的鼓樓矗立其中，侗族大歌被列為世界非物質文化遺產。", icon: "ri-music-line" },
      { name: "加榜梯田", description: "苗族先人歷代開墾的山地梯田，在晨霧中層層疊疊，倒映天光雲影，美如水墨畫。", icon: "ri-landscape-line" },
    ],
    included: ["全程舒適車輛", "5晚特色民宿", "主要景點門票", "苗族長桌宴", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 17,
    name: "川西秘境",
    subtitle: "最後的香格里拉",
    description: "稻城亞丁被稱為「最後的香格里拉」，三座神山仙乃日、央邁勇、夏諾多吉聳立於藍天之下，牛奶海呈現夢幻般的乳白藍色。這片土地保存著地球上最後一片淨土。",
    image: "https://readdy.ai/api/search-image?query=Majestic%20Daocheng%20Yading%20nature%20reserve%20with%20three%20holy%20snow-capped%20mountains%2C%20crystal%20clear%20Milk%20Lake%20reflecting%20peaks%2C%20prayer%20flags%2C%20alpine%20meadows%2C%20professional%20travel%20photography%2C%20pristine%20wilderness%20atmosphere&width=800&height=600&seq=117&orientation=landscape",
    price: "需要報價",
    duration: "8天7晚",
    features: ["雪山朝聖", "高原徒步", "藏族文化"],
    difficulty: "進階",
    bestSeason: "9月－10月",
    startCity: "成都",
    endCity: "成都",
    highlights: ["仙乃日雪山", "牛奶海", "五色海", "洛絨牧場", "色達喇榮五明佛學院"],
    itinerary: [
      { day: 1, title: "香港出發 → 成都", activities: ["由香港自駕出發", "抵達成都", "成吉思汗廣場參觀", "草原迎賓儀式"], accommodation: "雅安精品酒店", meals: "晚餐" },
      { day: 2, title: "雅安 → 康定", activities: ["翻越折多山隧道", "抵達雅安", "品嚉雅魚"], accommodation: "康定精品酒店", meals: "晚餐" },
      { day: 3, title: "康定 → 理塘", activities: ["抵達理塘", "翻越高爾寺山", "世界高城廣場"], accommodation: "理塘精品酒店", meals: "早餐、晚餐" },
      { day: 4, title: "理塘 → 芒康", activities: ["抵達芒康", "鹽井鹽田", "如美溫泉"], accommodation: "芒康精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "芒康 → 左貢", activities: ["抵達左貢", "業拉山72拐", "怒江大峽谷"], accommodation: "左貢精品酒店", meals: "早餐、晚餐" },
      { day: 6, title: "左貢 → 然烏湖", activities: ["抵達然烏湖", "來古冰川", "然烏湖冰川倒影"], accommodation: "然烏湖畔露營營地", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "然烏湖 → 林芝", activities: ["抵達林芝", "魯朗林海", "扎西崗村"], accommodation: "林芝精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "林芝 → 拉薩", activities: ["抵達拉薩", "米拉山口", "八廓街"], accommodation: "拉薩精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "拉薩 → 自駕返港", activities: ["抵達拉薩", "返回拉薩", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "牛奶海", description: "海拔4700米的高山湖泊，湖水呈現神秘的乳白色和藍色，倒映三神山，是亞丁最夢幻的景色。", icon: "ri-water-flash-line" },
      { name: "仙乃日", description: "亞丁三神山之首，海拔6032米，終年積雪，藏語意為「觀世音菩薩」，是藏族的聖山。", icon: "ri-mountain-line" },
      { name: "色達喇榮五明佛學院", description: "世界上最大的藏傳佛教學院，山谷中密密麻麻的紅色木屋震撼人心，黃昏時如血染天際。", icon: "ri-building-4-line" },
    ],
    included: ["全程越野車", "7晚住宿", "亞丁景區門票", "景區電瓶車", "全程餐飲", "高原醫療隨行", "旅遊保險"],
    excluded: ["個人消費", "馬匹租賃（選配）"],
  },
  {
    id: 18,
    name: "甘南藏區",
    subtitle: "九色香巴拉",
    description: "甘南藏族自治州是距離內地最近的藏區，拉卜楞寺是藏傳佛教格魯派六大寺院之一，扎尕那石城被稱為「上帝開的天窗」，郎木寺小鎮宛如藏區的瑞士。",
    image: "https://readdy.ai/api/search-image?query=Magnificent%20Gannan%20Tibetan%20region%20with%20Labrang%20Monastery%20golden%20roofs%2C%20Zhagana%20stone%20village%20nestled%20in%20dramatic%20mountain%20cliffs%2C%20Tibetan%20monks%20in%20red%20robes%2C%20prayer%20flags%20against%20blue%20sky%2C%20alpine%20grasslands%2C%20professional%20travel%20photography%2C%20spiritual%20sacred%20atmosphere&width=800&height=600&seq=118&orientation=landscape",
    price: "需要報價",
    duration: "7天6晚",
    features: ["藏傳佛教", "石城探秘", "草原牧歌"],
    difficulty: "中等",
    bestSeason: "5月－10月",
    startCity: "蘭州",
    endCity: "蘭州",
    highlights: ["拉卜楞寺轉經廊", "扎尕那石城", "郎木寺峽谷", "若爾蓋大草原", "花湖"],
    itinerary: [
      { day: 1, title: "香港出發 → 兰州", activities: ["由香港自駕出發", "抵達蘭州", "拉卜楞寺參觀", "藏式街道漫步"], accommodation: "蘭州精品酒店", meals: "晚餐" },
      { day: 2, title: "拉卜楞寺深度遊", activities: ["清晨僧人誦經儀式", "拉卜楞寺六學院", "甘加秘境草原"], accommodation: "蘭州精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "扎尕那石城", activities: ["扎尕那「上帝開的天窗」", "石城徒步探秘", "藏民家訪"], accommodation: "扎尕那石城民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "郎木寺", activities: ["郎木寺峽谷漫步", "白龍江源頭", "納摩峽谷"], accommodation: "郎木寺特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "若爾蓋草原", activities: ["若爾蓋大草原（中國最美高原草原）", "黃河第一彎", "花湖觀鳥"], accommodation: "若爾蓋草原民宿", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "碌曲 → 返回郎木寺", activities: ["則岔石林", "尕海湖", "返回郎木寺"], accommodation: "郎木寺特色民宿", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "返回蘭州", activities: ["臨夏回族文化體驗", "返回蘭州", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "拉卜楞寺", description: "世界上最長的轉經廊（3公里），格魯派六大寺院之一，每天清晨有千名僧侶誦經，莊嚴神聖。", icon: "ri-building-4-line" },
      { name: "扎尕那", description: "被稱為「上帝開的天窗」，石灰岩峭壁環抱藏族村落，晨霧中如世外桃源。", icon: "ri-landscape-line" },
      { name: "若爾蓋草原", description: "中國最美的高原草原之一，黃河在此劃出「S」形第一彎，花湖候鳥雲集，美不勝收。", icon: "ri-plant-line" },
    ],
    included: ["全程舒適車輛", "6晚藏式特色住宿", "主要景點門票", "全程餐飲", "藏文化講解", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 19,
    name: "恩施大峽谷",
    subtitle: "湖北秘境",
    description: "恩施大峽谷是湖北的隱秘寶藏，峽谷絕壁千仞，雲龍地縫如刀割裂大地，七星寨可俯瞰壯麗的峰叢地貌。土家族風情與峽谷奇景交融，是中國版科羅拉多大峽谷。",
    image: "https://readdy.ai/api/search-image?query=Stunning%20Enshi%20Grand%20Canyon%20in%20Hubei%20with%20dramatic%20vertical%20cliffs%20and%20deep%20gorge%2C%20hanging%20walkway%20on%20cliff%20face%2C%20lush%20green%20vegetation%2C%20mist%20flowing%20through%20valley%2C%20unique%20karst%20formations%2C%20professional%20travel%20photography%2C%20breathtaking%20natural%20wonder&width=800&height=600&seq=119&orientation=landscape",
    price: "HK$5,000起",
    duration: "5天4晚",
    features: ["峽谷徒步", "玻璃橋", "土家文化"],
    difficulty: "中等",
    bestSeason: "4月－10月",
    startCity: "武漢",
    endCity: "武漢",
    highlights: ["七星寨峰叢地貌", "雲龍地縫", "恩施女兒城", "騰龍洞地下河", "清江畫廊"],
    itinerary: [
      { day: 1, title: "香港出發 → 武漢", activities: ["由香港自駕出發", "抵達武漢", "恩施女兒城土家風情", "品嚐恩施特色美食"], accommodation: "恩施精品酒店", meals: "晚餐" },
      { day: 2, title: "恩施大峽谷", activities: ["七星寨（峰叢地貌俯瞰）", "雲龍地縫（地質奇觀）", "絕壁棧道"], accommodation: "恩施精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 3, title: "騰龍洞 → 清江", activities: ["騰龍洞（亞洲最大溶洞）", "清江畫廊遊船", "土家風雨橋"], accommodation: "清江河景民宿", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "土家族文化體驗", activities: ["彭家寨（中國最美土家族村寨）", "土家刺繡體驗", "利川龍船水鄉"], accommodation: "恩施精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "恩施土特產採購", activities: ["恩施土特產採購", "返回武漢", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "七星寨", description: "恩施大峽谷的核心景觀，七座山峰連綿起伏，奇峰異石在雲霧中若隱若現，壯麗如畫。", icon: "ri-mountain-2-line" },
      { name: "雲龍地縫", description: "如刀刃劃開的峽谷地縫，最深處達百米，兩壁相距僅數米，極為震撼，被稱為地球傷疤。", icon: "ri-landscape-line" },
      { name: "騰龍洞", description: "亞洲最大的溶洞，洞內有地下河流動，鐘乳石千姿百態，每年吸引數百萬遊客。", icon: "ri-compass-3-line" },
    ],
    included: ["全程舒適車輛", "4晚精品住宿", "大峽谷、騰龍洞門票", "清江遊船", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 20,
    name: "婺源",
    subtitle: "中國最美鄉村",
    description: "婺源是中國最美的農村，徽派白牆黑瓦民居點綴在金黃油菜花海之中。篁嶺曬秋是攝影師的天堂，古老村落、石板古道、廊橋古風，讓人流連忘返。",
    image: "https://readdy.ai/api/search-image?query=Picturesque%20Wuyuan%20countryside%20in%20spring%20with%20golden%20rape%20flower%20fields%20stretching%20across%20rolling%20hills%2C%20traditional%20Huizhou%20white-walled%20black-tiled%20villages%2C%20ancient%20bridges%20over%20streams%2C%20terraced%20farmlands%2C%20professional%20travel%20photography%2C%20peaceful%20rural%20beauty%2C%20soft%20natural%20lighting&width=800&height=600&seq=120&orientation=landscape",
    price: "HK$5,000起",
    duration: "4天3晚",
    features: ["油菜花海", "徽派建築", "古村漫步"],
    difficulty: "輕鬆",
    bestSeason: "3月－4月（油菜花）、10月－11月（曬秋）",
    startCity: "南昌",
    endCity: "南昌",
    highlights: ["篁嶺曬秋", "江嶺梯田油菜花海", "李坑水鄉古村", "思溪延村古建築", "彩虹橋廊橋"],
    itinerary: [
      { day: 1, title: "香港出發 → 南昌", activities: ["由香港自駕出發", "抵達南昌", "中山路騎樓老街漫步", "品嚐南昌特色小吃"], accommodation: "婺源古村特色民宿", meals: "晚餐" },
      { day: 2, title: "婺源 → 返港", activities: ["南普陀寺", "婺源大學校園", "自駕返港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "篁嶺", description: "被稱為「最美鄉村」，村民用圓形竹篾曬盤曬乾農作物，形成絢麗多彩的「曬秋」奇觀。", icon: "ri-home-smile-line" },
      { name: "江嶺梯田", description: "婺源最壯觀的油菜花梯田，春天金黃色花海從山腳蔓延至山頂，白牆民居點綴其中。", icon: "ri-plant-line" },
      { name: "彩虹橋", description: "建於宋代的古廊橋，橋上有廊亭供人休憩，是中國保存最好的古廊橋之一，全長140米。", icon: "ri-bridge-line" },
    ],
    included: ["全程舒適車輛", "3晚特色古村民宿", "篁嶺景區門票", "全程餐飲", "旅遊保險"],
    excluded: ["個人消費"],
  },
  {
    id: 21,
    name: "冰島極光環島",
    subtitle: "冰與火之境",
    description: "由香港自駕出發，一路向西穿越亞歐大陸，抵達北極圈邊緣的冰與火之島。冰島環島1號公路全長1332公里，穿越火山熔岩荒原、壯闊冰川絕壁、玄武岩黑沙灘與極光天幕。境內逾200座火山、萬條瀑布並存，極晝極夜交替，是地球上最極端也最震撼的自駕體驗。",
    image: "https://readdy.ai/api/search-image?query=Iceland%20Ring%20Road%20at%20night%20with%20spectacular%20vivid%20green%20and%20purple%20northern%20lights%20aurora%20borealis%20filling%20the%20entire%20sky%2C%20snow-covered%20volcanic%20mountains%2C%20frozen%20river%2C%20isolated%20arctic%20road%20disappearing%20into%20darkness%2C%20extreme%20cold%20wilderness%2C%20professional%20astrophotography%2C%20breathtaking%20otherworldly%20scene&width=800&height=600&seq=121&orientation=landscape",
    price: "需要報價",
    duration: "12天11晚",
    features: ["極光追獵", "冰川徒步", "地熱溫泉"],
    difficulty: "地獄",
    bestSeason: "9月－3月（極光）/ 6月－8月（極晝）",
    startCity: "雷克雅未克",
    endCity: "雷克雅未克",
    highlights: ["北極光全天幕奇觀", "Vatnajökull歐洲最大冰川", "黃金圈大陸板塊裂縫", "黑沙灘玄武岩石柱陣", "藍湖地熱溫泉", "西峽灣荒野砂石路"],
    itinerary: [
      { day: 1, title: "香港出發 → 踏上歐亞征途", activities: ["由香港自駕出發", "穿越內地口岸", "啟程歐亞大陸自駕征途", "適應長途駕駛節奏"], accommodation: "途中酒店", meals: "——" },
      { day: 2, title: "黃金圈（Golden Circle）", activities: ["辛格韋利爾國家公園（歐美板塊裂縫清晰可見）", "蓋錫爾間歇泉（每10分鐘自動噴發30米高）", "古佛斯黃金雙層瀑布"], accommodation: "南部精品農莊酒店", meals: "早餐、晚餐" },
      { day: 3, title: "南海岸 → 黑沙灘", activities: ["斯科加瀑布（可攀爬至瀑布頂部）", "黑沙灘Reynisfjara玄武岩石柱陣", "Dyrhólaey岬角海蝕岩拱門"], accommodation: "維克村精品小屋", meals: "早餐、晚餐" },
      { day: 4, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 10, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 11, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
      { day: 12, title: "冰川徒步極限挑戰", activities: ["Vatnajökull冰川徒步（歐洲最大冰川，面積8000平方公里）", "冰川湖Jökulsárlón浮冰奇觀", "鑽石海灘黑沙上巨型冰塊"], accommodation: "米湖地熱溫泉酒店", meals: "早餐、午餐、晚餐" },
    ],
    attractions: [
      { name: "極光（Aurora Borealis）", description: "冰島遠離光污染，9月至3月夜空中綠色光幕翻騰舞動，是全球最震撼的自然奇觀之一，值得專程追光。", icon: "ri-moon-line" },
      { name: "Vatnajökull冰川", description: "歐洲最大冰川，面積逾8000平方公里，冰川徒步時裂縫中折射出深邃的藍色光芒，令人窒息。", icon: "ri-mountain-line" },
      { name: "黃金圈", description: "辛格韋利爾板塊裂縫、蓋錫爾間歇泉、古佛斯瀑布三大奇觀，是冰島必遊的精華路線。", icon: "ri-route-line" },
      { name: "西峽灣", description: "冰島最荒僻地區，無鋪裝砂石山路驚心動魄，但Dynjandi瀑布的磅礴壯觀讓一切艱辛都值得。", icon: "ri-landscape-line" },
      { name: "藍湖溫泉", description: "火山地熱形成的天然礦泉，乳白色水色富含硅藻泥，極寒中泡湯仰望極光，終生難忘。", icon: "ri-water-flash-line" },
    ],
    included: ["全程4WD越野車租用", "11晚精品及特色住宿", "冰川徒步專業嚮導及裝備", "觀鯨船票", "藍湖溫泉入場券", "旅遊及緊急保險"],
    excluded: ["個人消費", "極光巴士追光（選配）", "部分景點入場費"],
  },
  {
    id: 22,
    name: "挪威峽灣極限",
    subtitle: "千年峽灣",
    description: "由香港自駕出發，一路向西穿越歐亞大陸，深入挪威西海岸蜿蜒公路。蓋朗格峽灣被譽為世界最美峽灣，羅弗敦群島懸崖公路驚心動魄，佈道石山頂俯瞰604米絕壁，大西洋公路在洶湧巨浪中淩波而過。挪威峽灣路以極窄、極陡、超多彎著稱，部分路段僅容一輛車通過，是歐洲公認最艱险的自駕公路系統。",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20Norway%20Geirangerfjord%20with%20sheer%20vertical%20cliff%20walls%20thousands%20of%20feet%20high%2C%20cascading%20multiple%20waterfalls%2C%20deep%20dark%20blue%20fjord%20water%2C%20tiny%20narrow%20dangerous%20road%20carved%20into%20cliff%20face%2C%20dramatic%20clouds%2C%20professional%20landscape%20photography%2C%20epic%20natural%20wonder&width=800&height=600&seq=122&orientation=landscape",
    price: "需要報價",
    duration: "11天10晚",
    features: ["峽灣公路", "絕壁徒步", "北極探秘"],
    difficulty: "地獄",
    bestSeason: "6月－9月（夏季通行）",
    startCity: "奧斯陸",
    endCity: "卑爾根",
    highlights: ["蓋朗格峽灣世界遺產", "佈道石604米垂直絕壁", "羅弗敦群島懸崖公路", "大西洋公路海浪穿越", "Trollstigen巨魔之路11個髮夾彎", "北角歐洲最北端"],
    itinerary: [
      { day: 1, title: "香港出發 → 奧斯陸", activities: ["由香港自駕出發", "抵達奧斯陸", "國家美術館（孟克《吶喊》）", "品嚐奧斯陸特色美食"], accommodation: "奧斯陸精品酒店", meals: "晚餐" },
      { day: 2, title: "奧斯陸 → 峽灣公路起點", activities: ["奧斯陸國家美術館", "峽灣公路出發駕車", "Heidal山谷初探"], accommodation: "古典農莊民宿", meals: "早餐、晚餐" },
      { day: 3, title: "巨魔之路（Trollstigen）", activities: ["Trollstigen 11個連續髮夾彎（11% 斜度）", "Stigfossen瀑布從路旁直流而下", "Geiranger村抵達峽灣底部"], accommodation: "蓋朗格峽灣木屋", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "蓋朗格峽灣深度遊", activities: ["峽灣遊船（新娘面紗瀑布、七姐妹瀑布）", "Dalsnibba山頂觀景台（1500米俯瞰峽灣）", "廢棄農場Skageflå峭壁徒步"], accommodation: "峽灣景觀精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "布道石（Preikestolen）", activities: ["布道石4小時往返徒步（海拔604米）", "山頂懸崖邊緣俯瞰呂瑟峽灣", "斯塔萬格小城漫步"], accommodation: "斯塔萬格海景民宿", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "大西洋公路（Atlantic Road）", activities: ["大西洋公路8座橋樑穿越海浪（風暴季最震撼）", "Bud小漁村", "克里斯蒂安松歷史小鎮"], accommodation: "海岸線特色民宿", meals: "早餐、晚餐" },
      { day: 7, title: "羅弗敦群島（Lofoten）", activities: ["長途自駕前往羅弗敦群島", "E10公路貫穿群島懸崖公路", "霍寧斯沃格漁村"], accommodation: "傳統挪威漁屋民宿（Rorbu）", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "羅弗敦群島環島", activities: ["Reine村（全挪威最美村莊）", "Nusfjord百年漁村", "山頂360度峽灣全景徒步"], accommodation: "傳統挪威漁屋民宿（Rorbu）", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "特羅姆瑟（極光之城）", activities: ["自駕前往特羅姆瑟（北緯69°）", "北極大教堂", "深夜極光追蹤（9月後）"], accommodation: "特羅姆瑟設計酒店", meals: "早餐、晚餐" },
      { day: 10, title: "卑爾根 → 弗洛姆齒軌火車", activities: ["自駕返回卑爾根", "弗洛姆齒軌鐵路（全球最壯麗鐵路之一）", "卑爾根布呂根歷史碼頭"], accommodation: "卑爾根精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 11, title: "返回香港", activities: ["卑爾根出發", "踏上返港自駕之路", "橫越歐亞大陸返回香港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "蓋朗格峽灣", description: "世界自然遺產，兩岸峭壁高達1400米，七姐妹瀑布與新娘面紗瀑布隔灣相對，是峽灣美學的頂點。", icon: "ri-landscape-line" },
      { name: "佈道石", description: "一塊水平突出的巨型石台，海拔604米懸空於呂瑟峽灣正上方，站在邊緣俯瞰令人腿軟心跳。", icon: "ri-mountain-2-line" },
      { name: "Trollstigen巨魔之路", description: "11個連續髮夾彎、11%坡度、旁邊就是數十米落差，是挪威公路工程最瘋狂也最壯觀的展示。", icon: "ri-route-line" },
      { name: "大西洋公路", description: "在怒海巨浪中穿越的8座橋樑，每逢風暴海浪直衝橋面，是世界十大最驚险公路之一。", icon: "ri-road-map-line" },
      { name: "羅弗敦群島", description: "北極圈內懸崖公路上的漁村群島，傳統紅色漁屋在峽灣倒影中如童話，秋冬可見極光。", icon: "ri-home-3-line" },
    ],
    included: ["全程電動或汽油車租用", "10晚住宿（含傳統漁屋）", "峽灣遊船票", "弗洛姆齒軌鐵路票", "旅遊保險"],
    excluded: ["個人消費", "部分景點入場費"],
  },
  {
    id: 23,
    name: "阿爾卑斯三國穿越",
    subtitle: "歐洲屋脊",
    description: "由香港自駕出發，穿越亞歐大陸抵達瑞士蘇黎世，再征服斯泰爾維奧山口（海拔2757米、48個髮夾彎）、格羅斯格洛克納高山公路等歐洲頂級極限公路。沿途少女峰冰川、馬特洪峰峰倒影、多洛米蒂岩塔，穿越瑞士、奧地利、意大利三國邊境，是自駕版的歐洲脊樑之旅。",
    image: "https://readdy.ai/api/search-image?query=Epic%20Alpine%20mountain%20road%20with%20dramatic%20countless%20hairpin%20switchbacks%20carved%20into%20sheer%20snow-covered%20mountain%20face%20at%20extreme%20altitude%2C%20Stelvio%20Pass%20style%20winding%20road%20with%2048%20turns%2C%20Swiss%20Austrian%20Alps%20panorama%2C%20turquoise%20mountain%20lake%20far%20below%2C%20professional%20adventure%20travel%20photography%2C%20extreme%20driving%20challenge&width=800&height=600&seq=123&orientation=landscape",
    price: "需要報價",
    duration: "12天11晚",
    features: ["極限山口", "三國邊境", "冰川湖泊"],
    difficulty: "地獄",
    bestSeason: "6月－10月（山口開放期）",
    startCity: "蘇黎世",
    endCity: "米蘭",
    highlights: ["斯泰爾維奧山口48髮夾彎", "少女峰冰川世界", "馬特洪峰鏡面倒影", "格羅斯格洛克納高山公路", "多洛米蒂岩塔群", "科莫湖星級彎道"],
    itinerary: [
      { day: 1, title: "香港出發 → 踏上歐亞征途", activities: ["由香港自駕出發", "穿越內地口岸", "啟程歐亞大陸自駕征途", "目標瑞士"], accommodation: "蘇黎世精品酒店", meals: "晚餐" },
      { day: 2, title: "蘇黎世 → 因特拉肯", activities: ["因特拉肯山城抵達", "圖恩湖與布里恩茨湖夾道美景", "夕陽下的少女峰遠眺"], accommodation: "因特拉肯湖景精品酒店", meals: "早餐、晚餐" },
      { day: 3, title: "少女峰冰川世界", activities: ["少女峰登頂（歐洲最高鐵路站3454米）", "冰宮冰川隧道漫步", "下山驅車格林德瓦冰川"], accommodation: "格林德瓦山景木屋", meals: "早餐、午餐、晚餐" },
      { day: 4, title: "格里姆塞爾山口 → 瓦萊州", activities: ["抵達格里姆塞爾山口（海拔2165米高山水庫）", "羅納冰川冰洞體驗（冰河紀遺跡）", "越境進入意大利奧斯塔谷"], accommodation: "奧地利因斯布魯克精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 5, title: "馬特洪峰 → 聖伯納德山口", activities: ["高爾內格拉特天文台（馬特洪峰正面倒影）", "聖伯納德山口（歷史最古老的阿爾卑斯山口）", "越境進入奧地利"], accommodation: "奧地利因斯布魯克精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 6, title: "多洛米蒂（Dolomites）", activities: ["多洛米蒂世界遺產石塔群", "三尖山Tre Cime徒步（最具代表性路線）", "科爾蒂納丹佩佐度假小鎮"], accommodation: "多洛米蒂山景精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 7, title: "多洛米蒂繼續探索", activities: ["塞拉山口環形公路（全球最美公路之一）", "Alpe di Siusi歐洲最大高山草甸", "多洛米蒂日落金山奇觀（Enrosadira）"], accommodation: "多洛米蒂傳統山莊", meals: "早餐、午餐、晚餐" },
      { day: 8, title: "斯泰爾維奧山口（終極挑戰）", activities: ["抵達斯泰爾維奧山口（海拔2757米，48個髮夾彎，歐洲最高鋪裝公路之一）", "山口頂部展望台", "越境進入奧地利"], accommodation: "奧地利因斯布魯克精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 9, title: "格羅斯格洛克納高山公路", activities: ["抵達格羅斯格洛克納高山公路（奧地利最高峰腳下）", "帕斯特茨冰川眺望台", "薩爾茨堡莫扎特故鄉漫步"], accommodation: "薩爾茨堡精品酒店", meals: "早餐、午餐、晚餐" },
      { day: 10, title: "越境瑞士 → 监加諾", activities: ["抵達監加諾", "科莫湖遊船（最後一程）", "米蘭大教堂廣場"], accommodation: "科莫湖畔精品別墅酒店", meals: "早餐、午餐、晚餐" },
      { day: 11, title: "米蘭", activities: ["科莫湖遊船（最後一程）", "米蘭大教堂廣場", "米蘭購物大道紀念品採購"], accommodation: "米蘭市中心精品酒店", meals: "早餐、午餐" },
      { day: 12, title: "自駕返港", activities: ["米蘭出發", "踏上返港自駕之路", "穿越歐亞大陸返回香港"], accommodation: "——", meals: "早餐" },
    ],
    attractions: [
      { name: "斯泰爾維奧山口", description: "海拔2757米，48個髮夾彎密集排列於山壁上，從山頂俯瞰如白色緞帶纏繞，是公認歐洲最偉大的公路。", icon: "ri-route-line" },
      { name: "多洛米蒂", description: "世界自然遺產，垂直橙紅色岩塔在夕陽中燃燒發光（Enrosadira現象），被譽為地球上最美的山脈。", icon: "ri-mountain-line" },
      { name: "馬特洪峰", description: "阿爾卑斯最具代表性的金字塔形山峰，晴天鏡面倒影於湖中，是地球上最多攝影師追拍的山景之一。", icon: "ri-landscape-line" },
      { name: "少女峰", description: "歐洲最高鐵路站3454米，冰宮隧道穿越萬年冰川，永久積雪的白色山頂在藍天映照下如夢如幻。", icon: "ri-mountain-2-line" },
      { name: "格羅斯格洛克納公路", description: "奧地利最壯麗的高山公路，俯瞰帕斯特茨冰川，沿途高山花卉和土撥鼠相伴，是公路駕駛的極致享受。", icon: "ri-road-map-line" },
    ],
    included: ["全程歐洲性能車租用", "11晚精品酒店及山莊", "少女峰登頂鐵路票", "多洛米蒂及少女峰等景點門票", "旅遊保險"],
    excluded: ["個人消費", "過路費及停車費（約€200）", "部分景點入場費"],
  },
];
